import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

const API_KEY = "d0d0e4b5f11eccb0cab298bbb66068273ab5a3d145a993577cc9a94a761273f6";

// Функция для склонения слова "предложение"
const getOfferText = (count) => {
  if (count % 10 === 1 && count % 100 !== 11) {
    return `${count} предложение`;
  } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
    return `${count} предложения`;
  } else {
    return `${count} предложений`;
  }
};

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://xalavach.ru/api/categories.php", {
        headers: { Authorization: `Bearer ${API_KEY}` },
      })
      .then((res) => {
        // Сортируем по display_order (по возрастанию), а затем по offers_count (по убыванию)
        const sortedCategories = res.data.sort((a, b) => {
          if (a.display_order === b.display_order) {
            return b.offers_count - a.offers_count;
          }
          return a.display_order - b.display_order;
        });

        setCategories(sortedCategories);
      })
      .catch((err) => console.error("Ошибка загрузки категорий:", err));
  }, []);

  return (
    <div className="pt-24 px-4 pb-10 min-h-screen bg-gradient-to-b from-[#1A1A2E] to-[#16213E] text-white">
      {/* Заголовок */}
      <div className="flex justify-center mb-6">
        <h2 className="text-lg sm:text-xl font-bold text-center px-4 py-2 rounded-md bg-[#222A3A] bg-opacity-80 text-blue-400 shadow-md">
          🔥 Популярные категории
        </h2>
      </div>

      {/* Контейнер списка */}
      <div className="flex flex-col space-y-4">
        {categories.map((category) => (
          <motion.div
            key={category.id}
            className="w-full bg-gradient-to-br from-[#232A3B] to-[#1E2A47] p-5 rounded-xl shadow-lg flex justify-between items-center
                       cursor-pointer transition-all hover:scale-105 hover:shadow-xl border border-gray-700"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            onClick={() => navigate(`/category/${category.id}`)}
          >
            <h3 className="text-md sm:text-lg font-semibold">{category.name}</h3>
            <span className="text-sm sm:text-md text-gray-400">{getOfferText(category.offers_count)}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
